import { callApi } from '@/utils/api'
import type { FlightArea, SaveFlightArea, FlightAreas, UpdateFlightArea } from '@/types/flightArea'
import type { ApiMessage, ApiMessageIds } from '@/types/apiResponse'

export type FlightAreaResponse = ApiMessage & Partial<ApiMessageIds>

// 飛行エリア取得
export async function fetchFlightAreas(): Promise<FlightArea[]> {
  const res = await callApi<FlightAreas>('/flight-areas', 'GET')
  return res.flight_areas ?? []
}

// 飛行エリア登録
export async function createFlightArea(
  body: SaveFlightArea,
): Promise<FlightAreaResponse | ApiMessageIds> {
  return await callApi<FlightAreaResponse, SaveFlightArea>('/flight-areas', 'POST', body)
}

//飛行エリア更新
export async function updateFlightArea(
  flightAreaId: number,
  body: UpdateFlightArea,
): Promise<FlightAreaResponse> {
  return await callApi<FlightAreaResponse, UpdateFlightArea>(
    `/flight-areas/${flightAreaId}`,
    'PUT',
    body,
  )
}

//飛行エリア削除
export async function deleteFlightArea(flightAreaId: number): Promise<FlightAreaResponse> {
  return await callApi<FlightAreaResponse>(`/flight-areas/${flightAreaId}`, 'DELETE')
}
